<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="ml-1 mr-50" icon="fa-solid fa-ticket" /> 折扣卷管理
    </h4>
    <b-tabs pills>
      <!-- Tab: coupon -->
      <b-tab active v-if="ability.can('read', 'coupons')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-ticket"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">優惠卷</span>
        </template>

        <coupon-list class="" />
      </b-tab>
      <!-- Tab: gift -->
      <b-tab v-if="ability.can('read', 'gift_vouchers')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-cart-shopping"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">購物禮券</span>
        </template>

        <gift-list class="" />
      </b-tab>
      <!-- Tab: reservation-->
      <b-tab v-if="ability.can('read', 'reservation_voucher')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-clock-rotate-left"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">預約券</span>
        </template>

        <reservations-list class="" />
      </b-tab>
      <!-- Tab: collection-->
      <b-tab v-if="ability.can('read', 'collection_voucher')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-hand-holding-dollar"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">自取券</span>
        </template>

        <collections-list class="" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import couponList from "./coupon/coupons-list/couponsList.vue";
import giftList from "./gift/gifts-list/giftsList.vue";
import reservationsList from "./reservation/reservations-list/reservationsList.vue";
import collectionsList from "./collection/collections-list/collectionsList.vue";
import ability from "@/libs/acl/ability";
export default {
  components: {
    couponList,
    giftList,
    reservationsList,
    collectionsList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {},
  data(){
    return{
      ability
    }
  }
};
</script>
